export function headerThemeColor() {
  const siteHeader = document.getElementById('site-header');
  const siteAlertBanner = document.getElementById('site-alert-banner');
  const sections = document.querySelectorAll('[data-section-theme]');

  if (!siteHeader) {
    return;
  }

  function setTheme(theme) {
    siteHeader.setAttribute('data-theme', theme);
  }

  function handleScroll() {
    sections.forEach((section) => {
      const br = section.getBoundingClientRect();
      const theme = section.getAttribute('data-section-theme');

      if (br.top + br.height > 50 && br.top < 50) {
        setTheme(theme);
      } else if (br.top >= 80 && siteAlertBanner) {
        setTheme(sections[0].getAttribute('data-section-theme'));
      }
    });
  }

  document.addEventListener('scroll', (e) => {
    handleScroll();
  });
    window.addEventListener('resize', handleScroll);
  handleScroll();
}

export function buttonStickyBottomThemeColor() {
  const sections = document.querySelectorAll('[data-section-theme]');
  const button = document.querySelector('.btn-contact-modal');

  if (!button) return;

  function setTheme(theme) {
    button.setAttribute('data-theme', theme);
  }

  function handleScroll() {
    // Position absolue du bas du bouton (dans le document, pas juste le viewport)
    const buttonBottomY = button.getBoundingClientRect().bottom + window.scrollY;

    sections.forEach((section) => {
      const sectionRect = section.getBoundingClientRect();
      const sectionTopY = sectionRect.top + window.scrollY;
      const sectionBottomY = sectionRect.bottom + window.scrollY;
      const theme = section.getAttribute('data-section-theme');

      // Vérifie si le bas du bouton est à l'intérieur de la section
      if (buttonBottomY >= sectionTopY && buttonBottomY <= sectionBottomY) {
        setTheme(theme);
      }
    });
  }

  document.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);
  handleScroll();
}
